// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0e98d14b","299":"aabd848f","453":"756eb101","667":"dfecded6","859":"0a938c45","977":"acdea2d4"}[chunkId] + ".chunk.js";
};